import { useState } from "react";

export interface IFindCepResult {
    cep?: string;
    logradouro?: string;
    complemento?: string;
    bairro?: string;
    localidade?: string;
    uf?: string;
    ibge?: string;
    gia?: string;
    ddd?: string;
    siafi?: string;
}

export const useFindCep = () => {
    const [loadingCep, setLoadingCep] = useState(false);
    
    const findCep = async (cep: string): Promise<IFindCepResult | null> => {
        setLoadingCep(true);

        try {
            if (!cep || cep.length < 8) {
                return null;
            }

            const response = await fetch(
                `https://viacep.com.br/ws/${cep}/json/`,
                {
                    method: "GET"
                }
            );

            if (response.status >= 400) {
                return null;
            }

            const result = await response.json();
    
            if (result.erro) {
                return null;
            }

            return result;
        } finally {
            setTimeout(() => {
                setLoadingCep(false);
            }, 1000);
        }
    }

    return { findCep, loadingCep };
}
